import { render, staticRenderFns } from "./bannerSetting.vue?vue&type=template&id=73697ede&scoped=true"
import script from "./bannerSetting.vue?vue&type=script&lang=js"
export * from "./bannerSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73697ede",
  null
  
)

export default component.exports